import {FormField} from "../form-field/form-field";

export class FormFieldSelect extends FormField{
    constructor(scope,$root){
        super(scope,$root);
    }

    getVal(){
        return this.$select.val();
    }

    setVal(val,noEvent){
        this.$select.find("[value='"+val+"']").prop("selected",true);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$select = this.$root.find(this.scope+"__select");
        this.$select.change(
            () => {
                this.$root.trigger("formField:changeVal");
            }
        );

        if(this.$select.attr("readonly")){
            this.$select.css("pointer-events","none");
        }
    }
}

